module.exports = __webpack_public_path__ + "img/billet_6.946052a5.jpg";